/**
 * mulberry32 PRNG factory (plan §0.2).
 * Increment 0x6D2B79F5. Returns draws in [0, 1).
 * Internal `let` is inherent to a PRNG (ADR-0004 · plan §3.5a) — the one mutable state
 * allowed inside the factory closure; never share an instance across streams.
 */
import type { Rng } from './types';

const MULBERRY_INC = 0x6d2b79f5;

/* eslint-disable functional/no-let -- PRNG state */
export function createRng(seed: number): Rng {
  let a = seed >>> 0;
  return (): number => {
    a = (a + MULBERRY_INC) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
/* eslint-enable functional/no-let */
